export default {"src":"/_next/static/media/logo.e15e666a.svg","height":41,"width":138,"blurWidth":0,"blurHeight":0};